import request from "@/utils/request.js"
// 获取 关于澳华
export function get_about(data){
  return request({
    	  method:'GET',
    	  url:'/about/get_about',
    	  params:data
    })
}

// 获取 投资者关系
export function get_investor(data){
  return request({
    	  method:'GET',
    	  url:'/about/get_investor',
    	  params:data
    })
}
// 公司介绍
export function get_company_data(data){
	return request({
			method:'GET',
			url:'/aohua.company/get_company_data',
			params:data
	  })
  }
